import { useTranslation } from 'react-i18next';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import { Icon } from '../../icon/icon';
import './ModuleCard.scss';
import { useNavigate } from 'react-router-dom';
import ROUTER from '../../../routers/Routers';
import { useEffect, useState } from 'react';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { Tooltip } from 'antd';
import { openMessageWarning } from '../../common/Message/openMessageWarning';

const ModuleCard = ({ item }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="module-card lg:w-[400px] w-[260px] shadow-custom flex flex-col items-end flex-shrink-0 h-full user-select-none">
      <div className="p-[16px] items-start self-stretch bg-fills-white">
        <div className="bg-primary-secondary rounded-[16px] lg:h-[240px] h-[140px]  w-full"></div>
      </div>
      <div className="flex p-[24px] pt-[60px] flex-col items-start gap-[16px] self-stretch">
        <spam className="lg:text-headline-small text-title-large !font-bold">
          {getValueFromString(item.name)}
        </spam>
        <Tooltip title={getValueFromString(item.description)} placement="top">
          <span className="text-body-medium ellipsis-multiline-3 h-[60px]">
            {getValueFromString(item.description)}
          </span>
        </Tooltip>
        {item.type_design !== 'normal' ? (
          <ButtonPrimaryLarge
            preIcon={<Icon.ICNavigateRight />}
            title={t('Design now')}
            onClick={() => {
              if (item.type_design !== 'normal') {
                navigate(ROUTER.DESIGN + '/' + item.type_design);
              } else {
                openMessageWarning({
                  content: t(
                    'This module is being updated, please wait a moment!'
                  ),
                });
              }
            }}
          />
        ) : (
          <ButtonPrimaryLarge title={t('Coming soon')} disabled={true} />
        )}
      </div>
      <div className="absolute lg:w-[433px] lg:h-[44px] flex-shrink-0 z-0 lg:-left-[17px] lg:top-[240px] lg:rounded-[430px] w-[315px] h-[32px] -left-[28px] top-[169px] module-card-shadow"></div>
      <div className="absolute flex items-center justify-center lg:left-[34px] lg:top-[60px] lg:w-[332px] lg:h-[240px] left-[16px] top-[33px] w-[228px] h-[164px]">
        <img
          src={item.row_image_url}
          alt="IC Kitchen cabinet"
          className="h-fit w-full lg:-mt-[20px] mt-[8px]"
        />
      </div>
    </div>
  );
};

export default ModuleCard;
